import {
    DELETE_USER_IMPERSONATION,
    DELETE_USER_IMPERSONATION_FAILURE,
} from 'store/actions/types';

export const deleteUserImpersonation = (payload) => {
    return {
        type: DELETE_USER_IMPERSONATION,
        payload: payload,
    };
};

export const deleteUserImpersonationFailure = (error) => {
    return {
        type: DELETE_USER_IMPERSONATION_FAILURE,
        error: error,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/users/impersonation/deleteUserImpersonation.js